import axios from 'axios';
import React, {useState, useEffect} from 'react'
import {
  EmailShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookShareButton,
  TelegramShareButton,
  TelegramIcon,
  WhatsappIcon,
  WhatsappShareButton
} from "react-share";
import firebase from '../firebase/config'

function Refereds() {
  
  const [btnMessage, setBtnMessage] = useState("Enviar invitación");
  let [message, setMessage] = useState("");
  let [user, setUser] = useState({});  
  let [userEmail, setUserEmail] = useState("");
  let [userName, setUserName] = useState("");
  let [emailBox, setEmailBox] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const SuccessComponent = ({msg}) => {
    return (
        <div className="success-alert">
            <span className="material-icons mr-2">done</span>
            {msg}
            <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
        </div>
    )
  }

  useEffect(() => {
    firebase.getCurrentUser().then((val)=>{
      setUser(val)
      setMessage(`Hey, únete a Priority Pet Aliados y disfruta de todo lo que tenemos para ofrecer\n \n🐶🐱🐷🐨🐤🐸\n \nSi eres un proveedor de servicios o productos usa este enlace:\nhttps://play.google.com/store/apps/details?id=com.ppa.ppet_aliado\n \nSi eres dueño de una mascota usa este otro enlace:\nhttps://play.google.com/store/apps/details?id=com.ppa.ppet_aliado\n \nEn ambos casos usa el código\n${val.codigoReferido}\npara que apoyes al aliado`)
    });
  }, [])

  return (
      <div className="main-content-container container-fluid px-4">
        {success && <SuccessComponent msg={successMsg === "" ? "Invitación enviada exitosamente" : successMsg}/>}
        { emailBox && <div className="cc-modal-wrapper fadeIn">
          <div className="c2-modal">
              <div className="cc-modal-header mb-2">
                  <h3 className="mb-0">Enviar invitación <br/> al correo electrónico</h3>
              </div>
              <div className="email-box my-3">
                <input value={userName} placeholder="Nombre del invitado" onChange={(e)=>{ setUserName(e.target.value) }} type="text" className="form-control mb-4"/>
                <input value={userEmail} placeholder="Email del invitado" onChange={(e)=>{ setUserEmail(e.target.value) }} type="email" className="form-control mb-4"/>
              </div>
              <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                <button onClick={()=>{setEmailBox(false)}} className="btn btn-outline-secondary mr-5">
                  Cancelar
                </button>
                <button onClick={()=>{
                  userName !== "" && userEmail !== "" ? sendMail() : console.log("Todos los campos son requeridos")
                }} className="btn btn-primary btn-block">Enviar invitación</button>
              </div>
          </div>
        </div>}
        <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
          <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
            <div className="row align-items-center">
              <div className="col">
                <p className="page-title"><span>Invita a un amigo</span></p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-1 mb-0">
            <div className="row align-items-center justify-content-space-around">
              <i className="material-icons color-white display-5">help_outline</i>
            </div>
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-lg-6 px-5">
            <p className="mb-4 bold color-primary">
              Elige tu red social favorita para invitar
            </p>
            <div className="row w-100 no-gutters align-items-center justify-content-spacebetween">
              <WhatsappShareButton url={message} windowHeight="700" windowWidth="700" className="share-card">
                <WhatsappIcon size={50} round={true} />
              </WhatsappShareButton>
              <FacebookShareButton url="https://play.google.com/store/apps/details?id=com.ppa.ppet_aliado" className="share-card">
                <FacebookIcon size={50} round={true} />
              </FacebookShareButton>
              <div onClick={()=>{ setEmailBox(!emailBox) }} className="cursor-pointer share-card">
                <EmailIcon size={50} round={true} />
              </div>
              <TelegramShareButton url={message} windowHeight="700" windowWidth="700" className="share-card">
                <TelegramIcon size={50} round={true} />
              </TelegramShareButton>
            </div>
          </div>
          <div className="col-lg-6 px-3">
            
            <p className="mb-2 alert alert-secondary">Código para referidos: <b>{user.codigoReferido}</b></p>
            
            <p className="mb-0 color-primary light">
              Invita a tus amigos para que descarguen la APP Priority Pet Club y puedan formar parte de nuestra gran comunidad. Por cada amigo que se afilie te regalaremos 100 Puntos
            </p>
            <div className="share-img-container">
              <img src="../images/icons/invitation.svg" alt=""/>
            </div>
          </div>
        </div>
        
    </div>
  )

  async function sendMail(){
    await axios.get(`https://us-central1-priority-pet.cloudfunctions.net/sendInvitationEmail?dest=${userEmail}&aliado=${user.nombre}&username=${userName}`).then(()=>{
      firebase.db.collection('Referidos').doc(userEmail).set({
        aliadoId: user.aliadoId,
        referidoEmail: userEmail,
        registrado: false
      });
      setEmailBox(false)
      setSuccessMsg("Invitación enviada exitosamente")
      setSuccess(true)
      setTimeout(() => {
        setSuccess(false)
      }, 4000);
    });
  }

}

export default Refereds
